export default {
  navigation: {
    menuLinks: {
      admin: "Администратор",
      runTask: {
        general: "Запуск задач",
        singleTask: "Одиночный",
        multiTask: "Мультизапуск"
      },
      statusTask: {
        general: "Статус задач",
        running: "Запущенные",
        finished: "Завершенные",
        deleted: "Удаленные"
      },
      commonTask: {
        general: "Общие задачи",
        processes: "Просмотр процессов",
        services: "Запуск сервисов",
        logs: "Журналы"
      },
      reference: {
        general: "Справочники",
        databases: "Базы данных",
        apps: "Приложения",
        servers: "Сервера",
        users: "Пользователи",
        roles: "Роли",
        appParams: "Параметры приложений",
        upgrades: "Обновления"
      },
      config: {
        general: "Конфигурация",
        configTree: "Конфигурация приложений",
        visuals: "Визуализация",
        configTasks: "Настройка задач",
        roleSections: "Базы и роли",
        sectionTasks: "Приложения и задачи",
        roleTasks: "Задачи и роли" 
      },
      cron: {
        general: "Планировщик",
        scheduler: "Редактор",
        history: "История"
      }
    },
    headerTitles: {
      singleTask: "Запуск задач",
      multiTask: "Мультизапуск обновлений",
      running: "Запущенные задачи",
      finished: "Завершенные задачи",
      deleted: "Удаленные задачи",
      processes: "Просмотр процессов",
      services: "Запуск сервисов",
      logs: "Журналы",
      databases: "Справочник баз данных",
      apps: "Справочник приложений",
      servers: "Справочник серверов",
      users: "Справочник пользователей",
      roles: "Справочник ролей",
      appParams: "Параметры приложений",
      upgrades: "Справочник обновлений",
      configTree: "Конфигурация приложений",
      visuals: "Визуализация",
      configTasks: "Настройка задач",
      roleSections: "Базы к ролям",
      roleTasks: "Задачи к ролям",
      sectionTasks: "Задачи к приложениям",
      scheduler: "Редактор планировщика",
      history: "История планировщика",
      passwordChange: "Изменение пароля"
    },
    userMenu: {
      version: "Версия web",
      mainServerVersion: "Версия агента",
      userRole: "Роль",
      user: "Пользователь",
      serversVersions: "Версии агентов",
      hardwareInfo: "Контроль ресурсов",
      clearLocalStorage: "Очистить память",
      backup: "Резервная копия",
      passwordChange: "Смена пароля",
      themeChange: "Смена темы",
      themeTitle: "Выбор темы",
      themeDark: "Обсидиан",
      themeDesktop: "Классика",
      lastErrors: "Последние ошибки",
      exit: "Выход",
      headerDialog: {
        versions: "Версии",
        generalAgentVersion: "Версия главного агента",
        tinyAgentsVersion: "Версии tiny-агентов",
      },
      headerMessages: {
        plsRefreshPage: "Обновите страницу, пожалуйста",
        noMistakes: "Ошибок нет",
        lastMistakes: "Последние ошибки",
      }
    },
    configTaskForm: {
      param: "Параметр",
      name: "Название",
      lenght: "Длина",
      cancel: "Отмена"
    },
    configTree: {
      server: "Сервер",
      servers: "Сервера",
      notExported: "не экспортирован",
      notExportedPlural: "не экспортированы"
    },
    commonTree: {
      saveInFile: "Сохранить в файл",
      showScroll: "Скролл вправо",
      details: "Подробнее",
      taskNotCompleted: "Задача не завершена"
    }
  }
};
